module.exports = __webpack_public_path__ + "static/media/icon_knowledgebase.b8c40d8a.svg";